module.exports = __webpack_public_path__ + "media/Bones_extract.7f2fed98.mp3";